import TablePlainDataCell from './TablePlainDataCell';

interface StageCellProps {
    title: string;
    subTitle?: string;
    activeColor: string;
    dataLabel: string | number | undefined;
}

export default ({ dataLabel, title, subTitle, activeColor }: StageCellProps) => {
    return (
        <TablePlainDataCell dataLabel={dataLabel}>
            <div>
                <p className="text-gray-900 whitespace-no-wrap text-base capitalize">
                    <span className="w-2.5 h-2.5 rounded-full inline-block mr-2" style={{ backgroundColor: activeColor }} />
                    {title}
                </p>
                {subTitle && (
                    <p className="text-gray-500 whitespace-no-wrap text-sm capitalize">
                        <span className="w-2.5 h-2.5 rounded-full inline-block mr-2" />
                        {subTitle}
                    </p>
                )}
            </div>
        </TablePlainDataCell>
    );
};
